<template>
  <!--begin::Toolbar wrapper-->
  <div class="d-flex align-items-stretch flex-shrink-0">
    <div class="topbar d-flex align-items-stretch flex-shrink-0">
      <!--begin::User-->
      <div
        class="d-flex align-items-center me-n3 ms-1 ms-lg-3"
        id="kt_header_user_menu_toggle"
      >
        <!--begin::Menu-->
        <router-link
          to="/sign-in"
          v-if="!userMenu"
          class="btn btn-sm btn-app mx-2"
        >
          เข้าสู่ระบบ
        </router-link>
        <!-- <router-link
          to="/sign-up"
          v-if="!userMenu"
          class="btn btn-sm btn-app mx-2 d-none d-md-block"
        >
          สมัคสมาชิก
        </router-link> -->
        <div
          v-if="userMenu"
          class="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px"
          data-kt-menu-trigger="click"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-end"
          data-kt-menu-flip="bottom"
          style="position: relative;"
        >
       
          <img
            :src="userInfo && userInfo.imageProfile ? userInfo.imageProfile : 'media/avatars/blank.png'"
            alt="metronic"
            style="object-fit:cover;border-radius: 50%;width:100%;height:100%;"
            @error="setAltImg"
          />

          <div v-if="userMandatory != null && userMandatory == 2"
            class="mandatory-badge bg-success"
            data-label="ผ่านการยืนยัน"
            ><i class="fa fa-check" style="color: white;"></i
          ></div>
          <div v-else-if="userMandatory == 1"
            class="mandatory-badge bg-warning"
            data-label="รออนุมัติ"
            ><i class="fa fa-clock" style="color: white;"></i
          ></div>
          <div v-else-if="userMandatory == 0 || userMandatory == null || userMandatory == 3"
            class="mandatory-badge bg-danger"
            data-label="ยังไม่ยืนยัน"
            ><i class="fa fa-times" style="color: white;"></i
          ></div>
        </div>
        <span v-if="userMenu" class="d-none d-lg-block mx-2" style="min-width: 0; max-width: 200px;">
          <b style="display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ userInfo.firstName + " " + userInfo.lastName }}</b>
          <span style="display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 12px; color: #9ca3af;">{{ userInfo.email }}</span>
        </span>
        <KTUserMenu></KTUserMenu>
        <!--end::Menu-->
      </div>
      <!--end::User -->
      <!-- {{route.path}} -->
      <!--begin::Heaeder menu toggle-->

      <!-- <div
      
        class="d-flex align-items-center d-lg-none ms-2 me-n3"
        title="Show header menu"
      >
        <div
          class="btn btn-icon btn-active-light-primary"
          id="kt_header_menu_mobile_toggle"
        >
          <span class="svg-icon svg-icon-1">
            <inline-svg src="media/icons/duotone/Text/Toggle-Right.svg" />
          </span>
        </div>
      </div> -->
      <!--end::Heaeder menu toggle-->
    </div>
  </div>
  <!--end::Toolbar wrapper-->
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";
import { useRoute } from "vue-router";
import axios from "axios";
const userMenu = ref(false);
const userMandatory = ref<number | null>(null);

export default defineComponent({
  name: "topbar",
  components: {
    KTUserMenu,
  },
  setup() {
    const route = useRoute();
    let userInfo: any = null;
    try {
      userInfo = JSON.parse(localStorage.getItem("userInfo") || "null");
    } catch (error) {
      userInfo = null;
    }
    if (localStorage.getItem("id_token") != null) {
      axios
        .get(process.env.VUE_APP_API_URL + "/getProfile?id=" + localStorage.getItem("u_id"), {
          headers: {
            "token": localStorage.getItem("id_token")
          },
        })
        .then((response) => {
            //  console.log(response.data.data);
            userMandatory.value = response.data.data.currentSpecialistStatus;
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem("id_token");
            location.reload();
          }
          console.log(error);
        });
      userMenu.value = true;
      if (userInfo && userInfo.imageProfile) {
        if (userInfo.imageProfile.indexOf("http") ==-1) {
          userInfo.imageProfile = process.env.VUE_APP_IMG_URL + userInfo.imageProfile
        }
      } 
      // console.log(userInfo);
    }
    // onMounted(() => {});
    return {
      route,
      userMenu,
      userInfo,
      userMandatory,
    };
    // watch(
    //   () => route.path,
    //   () => {
    //     nextTick(() => {
    //       reinitializeComponents();
    //     });
    //   }
    // );
  },
  methods: {
    setAltImg(event) {
      event.target.src = "media/avatars/blank.png";
    },
  },
});
</script>

<style scoped>
.mandatory-badge {
  position: absolute;
  bottom: -3px;
  right: -3px;
  width: 14px;
  height: 14px;
  font-size: 8px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: default;
}
.mandatory-badge::after {
  content: attr(data-label);
  position: absolute;
  bottom: 18px;
  right: 0;
  background: rgba(0,0,0,0.75);
  color: #fff;
  font-size: 11px;
  white-space: nowrap;
  padding: 3px 7px;
  border-radius: 4px;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s;
}
.mandatory-badge:hover::after {
  opacity: 1;
}
</style>
